export default __webpack_public_path__ + "static/media/maybe.978f7fcb.svg";